<script setup lang="ts">
import { computed } from 'vue'
import { useStore } from 'vuex'
import { useRoute } from 'vue-router'

import RolesEditor from '@/components/roles/RolesEditor.vue'

const store = useStore()
const route = useRoute()

const loaded = computed(() => store.getters['access/loaded'])
const roleId = computed(() => Number(route.params.role_id))
</script>

<template>
  <RolesEditor v-if="loaded" :key="roleId" :role-id="roleId" />
</template>
